import React from 'react';
import { Form, Input } from 'antd';
import './CommonInput.less';
import _ from "lodash";
import { connect } from "react-redux";

const CommonInput = (props = { required: false, rules: [], type: 'text', formItemStyle: {}, requiredMessage: '', ...props }) => {
  return (
    <Input
      id="commonInput"
      autoComplete="new-account"
      style={{
        borderRadius: '15px',
        height: '50px',
        color: '#125346',
        padding: '0px 16px',
        backgroundColor: '#FFF',
        boxShadow: '0px 3px 6px rgba(0,0,0,0.16)',
        width: '100%',
        ...props.style,
      }}
      type={props.type}
      value={props.value}
      onChange={props.onChange}
      placeholder={props.placeholder}
    />
  );
}

const mapStateToProps = (state) => {
  return {
    theme: _.get(state, 'Global.theme', 'light'),
    themeMode: _.get(state, 'Global.themeMode', 'dark'),
    color: _.get(state, 'Global.color', {}),
    i18n: _.get(state, 'Global.i18n', {}),
    i18nMode: _.get(state, 'Global.i18nMode', {}),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CommonInput);